
namespace RioERP.Invoices {
    export class InvoiceHsnColumns {
        static columnsKey = 'Invoices.InvoiceHsn';
    }
}